/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type GroupHistoryListQueryVariables = Types.Exact<{
  groupName: Types.Scalars['String']['input']
}>

export type GroupHistoryListQuery = {
  __typename?: 'Query'
  history: Array<{
    __typename?: 'BackofficeUserManagementGroupHistory'
    id: string
    name: string
    action: string
    affectedAttribute: string
    description: string
    author: string
    timestamp: string
    notes: string
  }> | null
}

export const GroupHistoryListDocument = gql`
    query GroupHistoryList($groupName: String!) {
  history: backofficeUserManagementGroupHistory(name: $groupName) {
    id
    name
    action
    affectedAttribute
    description
    author
    timestamp
    notes
  }
}
    `

/**
 * __useGroupHistoryListQuery__
 *
 * To run a query within a React component, call `useGroupHistoryListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupHistoryListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupHistoryListQuery({
 *   variables: {
 *      groupName: // value for 'groupName'
 *   },
 * });
 */
export function useGroupHistoryListQuery(
  baseOptions: Apollo.QueryHookOptions<
    GroupHistoryListQuery,
    GroupHistoryListQueryVariables
  > &
    (
      | { variables: GroupHistoryListQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GroupHistoryListQuery, GroupHistoryListQueryVariables>(
    GroupHistoryListDocument,
    options,
  )
}
export function useGroupHistoryListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GroupHistoryListQuery,
    GroupHistoryListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GroupHistoryListQuery,
    GroupHistoryListQueryVariables
  >(GroupHistoryListDocument, options)
}
// @ts-ignore
export function useGroupHistoryListSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GroupHistoryListQuery,
    GroupHistoryListQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GroupHistoryListQuery,
  GroupHistoryListQueryVariables
>
export function useGroupHistoryListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GroupHistoryListQuery,
        GroupHistoryListQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GroupHistoryListQuery | undefined,
  GroupHistoryListQueryVariables
>
export function useGroupHistoryListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GroupHistoryListQuery,
        GroupHistoryListQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GroupHistoryListQuery,
    GroupHistoryListQueryVariables
  >(GroupHistoryListDocument, options)
}
export type GroupHistoryListQueryHookResult = ReturnType<
  typeof useGroupHistoryListQuery
>
export type GroupHistoryListLazyQueryHookResult = ReturnType<
  typeof useGroupHistoryListLazyQuery
>
export type GroupHistoryListSuspenseQueryHookResult = ReturnType<
  typeof useGroupHistoryListSuspenseQuery
>
export type GroupHistoryListQueryResult = Apollo.QueryResult<
  GroupHistoryListQuery,
  GroupHistoryListQueryVariables
>
